import { useTranslation } from 'react-i18next';
import { Button, Col, RichTextRenderer, Row, Title, message } from 'ui';
import { useAcceptConsentsMutation } from '../../../queries';
import type { Consent } from '../../../types';
import { ContinueReading } from './continue-reading';

type P = {
  consent: Consent;
  onAccept: () => void;
  onCancel: () => void;
};

const ConsentDetail = ({ consent, onAccept, onCancel }: P) => {
  const { t } = useTranslation();
  const { isPending: isAcceptingConsents, mutate: acceptConsents } = useAcceptConsentsMutation();

  const acceptConsent = () => {
    acceptConsents(
      { consentIds: [consent.id] },
      {
        onError() {
          message.error(t('Failed to confirm consent: {{name}}', { name: consent.name }));
        },
        onSuccess() {
          onAccept();
        },
      },
    );
  };

  return (
    <Row gutter={['ms', 'ms']}>
      <Col span={24}>
        <Title level={2} marginBottom>
          {consent.name}
        </Title>
        <RichTextRenderer data={consent.htmlContent} />
        <ContinueReading />
      </Col>
      <Col span={consent.consented ? 24 : 12}>
        <Button block onClick={onCancel}>
          Back
        </Button>
      </Col>
      {consent.consented ? null : (
        <Col span={12}>
          <Button block loading={isAcceptingConsents} onClick={acceptConsent} type="primary">
            Confirm
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default ConsentDetail;
